// A transition carries live DOM nodes, so it cannot travel through route params.
let pendingTransition = null;

export function prepareCaseTransition(slug, cloneDom) {
  pendingTransition = { slug, cloneDom };
}

export function takeCaseTransition(slug) {
  if (!pendingTransition || pendingTransition.slug !== slug) return null;
  const { cloneDom } = pendingTransition;
  pendingTransition = null;
  return cloneDom;
}
